<div class = "main">
    <div class="bgimg-2">
        <div class="caption">
            <div class="toptrans">
                <div class="content">
                    <div class="name">
                        ACCESS IT!
                    </div>
                    
                    <div class="tagline">
                        An interactive platform for raising awareness on disabilities.
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div style="color: #777;background-color:#c7d7f0;text-align:center;padding:50px 80px;text-align: justify;">
        <h2 style="text-align:center;font-family: Georgia, 'Times New Roman', Times, serif;">Our Goal</h2>
        <p class="info">We provide a picture-based communication system for people with speech challenges.This
            platform helps user to interact with disabled people and also to learn basic of American Sign Language through
            inbuilt translators and other features.
        </p>
    </div>
    <div class="bgimg-1">
        <div class="caption">

        </div>
    
    </div>

</div>